export const comparePages = [
  {
    slug: 'stripe',
    path: '/compare/stripe',
    title: 'Tillio POS vs Stripe Dashboard',
    seoTitle: 'Tillio POS vs Stripe Dashboard App | Restaurant Checkout',
    seoDescription:
      'Stripe’s Dashboard is for monitoring your business. Tillio is restaurant POS for orders, tables, and in-person checkout—connected to the Stripe account you already have.',
    images: {
      hero: '/feature-payments.webp',
      section1: '/showcase-payments.webp', // Stripe is your payments backbone
      section2: '/feature-pos.webp', // Tillio is your restaurant checkout
    },
    eyebrow: 'Compare',
    intro:
      'Stripe built tools to run payments infrastructure and review your business. Tillio built the front-of-house: tickets, tables, kitchen, and Terminal checkout on top of the Stripe account you connect.',
    leftLabel: 'Stripe Dashboard',
    rightLabel: 'Tillio POS',
    leftTag: 'Back office',
    rightTag: 'Front of house',
    leftPoints: [
      'Check balances and payouts',
      'Review charges and disputes',
      'Manage Stripe products and customers',
      'Monitor fraud and tax reports',
      'Configure Connect and Terminal in Stripe',
    ],
    rightPoints: [
      'Take orders and fire kitchen tickets',
      'Seat tables and manage open checks',
      'Pair Stripe Terminal readers on the floor',
      'Tips, split bills, and receipts at checkout',
      'Menus, team roles, and sales analytics',
    ],
    rows: [
      { feature: 'Restaurant order taking', stripe: false, tillio: true },
      { feature: 'Table / floor management', stripe: false, tillio: true },
      { feature: 'Kitchen display workflows', stripe: false, tillio: true },
      { feature: 'Customer-facing display', stripe: false, tillio: true },
      { feature: 'Stripe Terminal in-person checkout', stripe: 'Limited', tillio: true },
      { feature: 'Tips & split checks in POS', stripe: false, tillio: true },
      { feature: 'Balances, payouts, disputes', stripe: true, tillio: 'Via Stripe' },
      { feature: 'Connect existing Stripe account', stripe: 'N/A', tillio: true },
      { feature: 'PCI card handling', stripe: true, tillio: 'Via Stripe' },
    ],
    sections: [
      {
        title: 'Stripe is your payments backbone',
        description:
          'Processing, payouts, identity verification, and card security stay with Stripe. Your money settles to your Stripe balance on Stripe’s schedule—Tillio does not hold card funds.',
        bullets: [
          'You authorize Tillio with Stripe Connect OAuth',
          '1.1% Tillio flat rate + Stripe processing fees',
          'Disputes and refunds remain Stripe-native',
          'Dashboard stays the place to monitor money',
        ],
      },
      {
        title: 'Tillio is your restaurant checkout',
        description:
          'A Dashboard is not a dining-room POS. Tillio runs the floor so amounts, tips, and tickets stay accurate when the reader fires.',
        bullets: [
          'Orders tied to tables and stations',
          'Hardware that fits restaurant service',
          '$99/mo platform fee, unlimited devices',
          'See How it works for setup in three steps',
        ],
      },
    ],
    relatedFeatureSlugs: ['payments', 'point-of-sale', 'analytics'],
  },
  {
    slug: 'payment-processors',
    path: '/compare/payment-processors',
    title: 'Keep Stripe vs Switching Processors',
    seoTitle: 'Keep Your Stripe Account vs Square or Toast | Tillio POS',
    seoDescription:
      'Many restaurant POS systems lock you into their payment processor. Tillio connects the Stripe account you already have—so you keep Stripe while running modern POS.',
    images: {
      hero: '/category-take-payments.webp',
      section1: '/feature-payments.webp', // Why restaurants keep Stripe
      section2: '/hardware-terminal.webp', // What you pay with Tillio
    },
    eyebrow: 'Compare',
    intro:
      'Switching POS often means switching processors, re-underwriting, and losing the Stripe Dashboard you already trust. Tillio is built to connect your existing Stripe account and process in-person cards with Terminal.',
    leftLabel: 'Locked-in POS processors',
    rightLabel: 'Tillio + your Stripe',
    leftTag: 'Typical bundle',
    rightTag: 'Bring your Stripe',
    leftPoints: [
      'New merchant account under their brand',
      'Rates and holds controlled by the POS vendor',
      'Migrate history and payouts again if you leave',
      'Hardware often leased or tied to their stack',
      'Back office lives outside Stripe',
    ],
    rightPoints: [
      'Connect the Stripe account you already verified',
      'Payouts and disputes stay in Stripe Dashboard',
      'Stripe Terminal readers you can buy outright',
      'Restaurant POS: orders, tables, kitchen, team',
      'Transparent $99/mo + 1.1% Tillio rate',
    ],
    rows: [
      { feature: 'Use existing Stripe account', stripe: false, tillio: true },
      { feature: 'Stripe Dashboard for money', stripe: false, tillio: true },
      { feature: 'Restaurant POS workflows', stripe: 'Varies', tillio: true },
      { feature: 'In-person Terminal / readers', stripe: true, tillio: true },
      { feature: 'Portable processor relationship', stripe: false, tillio: true },
      { feature: 'Clear software + card pricing', stripe: 'Varies', tillio: true },
    ],
    sections: [
      {
        title: 'Why restaurants keep Stripe',
        description:
          'If you already run online or in-person payments on Stripe, you shouldn’t have to abandon that account to get a modern floor system. Tillio adds POS; Stripe remains the rail.',
        bullets: [
          'One Stripe login for web and in-person history',
          'Familiar payout timing and reporting',
          'OAuth connect—no API key paste ritual',
          'Card data never stored by Tillio',
        ],
      },
      {
        title: 'What you pay with Tillio',
        description:
          'Platform access is $99/mo with unlimited devices for your location. Card payments include a 1.1% Tillio flat rate plus Stripe’s own processing rates (see stripe.com/pricing). Hardware is optional and purchased as needed.',
        bullets: [
          'No setup fee to start software',
          'No per-tablet POS license tax',
          'Readers listed on Card readers and Hardware',
          'Compare details on the Pricing page',
        ],
      },
    ],
    relatedFeatureSlugs: ['payments', 'point-of-sale', 'team-management'],
  },
]

export function getComparePage(slug) {
  return comparePages.find((p) => p.slug === slug)
}
